import React from 'react'
import { MutationTuple, QueryResult, QueryTuple } from '@apollo/client'
import _ from 'lodash/fp'
import Loader, { LoaderContainer } from 'components/Loader'

interface Props<
Q extends { [key: string]: QueryResult },
M extends { [key: string]: MutationTuple<any, any> },
LQ extends { [key: string]: QueryTuple<any, any> }
> {
  queries: Q,
  mutations: M,
  lazyQueries: LQ,
  children: (data: { queries: Q, mutations: M, lazyQueries: LQ }) => React.ReactNode,
  showLoader?: boolean
}

const GraphQLHandler = <
Q extends { [key: string]: QueryResult },
M extends { [key: string]: MutationTuple<any, any> },
LQ extends { [key: string]: QueryTuple<any, any> }
>(props: Props<Q, M, LQ>) => {
  const queriesPairs = props.queries ? _.toPairs(props.queries) : []
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const loading = _.some(([key, result]) => result.loading)(queriesPairs)
  /* eslint-enable @typescript-eslint/no-unused-vars */

  return (
    <>
      {(loading && props.showLoader) ?
        <LoaderContainer>
          <Loader />
        </LoaderContainer> :
        <>
          {props.children({
            queries: props.queries,
            mutations: props.mutations,
            lazyQueries: props.lazyQueries
          })}
        </>
      }
    </>
  )
}

GraphQLHandler.defaultProps = {
  queries: {},
  mutations: {},
  lazyQueries: {},
  hideErrors: [],
  showLoader: true
}

export default GraphQLHandler
